<template>
  <div class='main-infos'>
      <img v-if="errorType == 'empty'" class="error-image" src="/static/images/file_empty.svg"></img>
      <img v-if="errorType == 'delete'" class="error-image" src="/static/images/file_delete.svg"></img>
      <img v-if="errorType == 'ie'" class="ie" src="/static/images/ie.png"></img>
      <div class="tips">{{ errorContent }}</div>
  </div>
</template>

<script>
export default {
  name: 'errorPage',
  props: ['errorType','errorContent']
}
</script>

<style scoped>
.main-infos {
  width: 100%;
  padding: 20px 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 300px;
  justify-content: center;
}
@media (min-width: 768px) {
  .main-infos {
  min-height: 600px;
  justify-content: center;
  }
}

.error-image {
  width: 150px;
  height: 150px;
}
.ie{
  width: 300px;
  height: 300px;
}

/* ::-webkit-scrollbar {
  display: none;
} */
.tips {
  text-align: center;
  color: #C4C7CC;
  width: 100%;
  line-height: 1.5;
  word-wrap:break-word;
  word-break:normal;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/errorPage.vue